module.exports = __webpack_public_path__ + "static/media/homepage.51759f87.svg";